


import AtomButton from "../atoms/AtomButton.vue";
import AtomImage from "../atoms/AtomImage.vue";
import MoleculeProgressBar from "../molecules/MoleculeProgressBar.vue";
import Layout from "../layout/Layout.vue";
import LayoutDefaultBlock from "../layout/LayoutDefaultBlock.vue";
import {computed, defineComponent, ref, watch} from "@vue/composition-api";
import {useStore} from "vuex-composition-helpers";

export default defineComponent({
  name: "QuestionComponent",
  components: {
    AtomButton,
    AtomImage,
    MoleculeProgressBar,
    Layout,
    LayoutDefaultBlock
  },
  setup: () => {
    const store = useStore()
    const question = ref()

    watch(() => store.state.explanationActive, () => {
      if (!store.state.explanationActive) {
        question.value.focus()
      }
    })

    function isChosen(choice: boolean): boolean {
      return store.getters.currentAnswer == choice;
    }

    function setAnswer(answer: boolean): void {
      store.dispatch("setAnswer", answer);
      store.commit("moveForwards");

      if (store.getters.isFinished) {
        store.commit("goToResults");
      }
    }

    function handleKeyEvent(event: KeyboardEvent): void {
      if (event.defaultPrevented) {
        return;
      }

      switch (event.code || event.key) {
        case "KeyY":
        case "KeyJ":
          setAnswer(true);
          break;
        case "KeyN":
          setAnswer(false);
          break;
        case "ArrowLeft":
          store.dispatch("moveBackwards");
          break;
        case "ArrowRight":
          store.dispatch("moveForwards");
          break;
      }
    }

    function handleSwipe(direction: string): void {
      if (direction === "left") {
        setAnswer(false);
      }

      if (direction === "right") {
        setAnswer(true);
      }
    }

    return {
      question,
      isChosen,
      setAnswer,
      handleSwipe,
      handleKeyEvent,
      progress: computed(() => store.getters.progress),
      moveForwards: () => store.dispatch('moveForwards'),
      moveBackwards: () => store.dispatch('moveBackwards'),
      toggleExplanation: () => store.commit('toggleExplanation'),
      progressLabel: computed(() => store.getters.progressLabel),
      canMoveForwards: computed(() => store.getters.canMoveForwards),
      currentQuestion: computed(() => store.getters.currentQuestion),
      explanationActive: computed(() => store.state.explanationActive),
      canMoveBackwards: computed(() => store.getters.canMoveBackwards),
    }
  }
})
